module.exports = __webpack_public_path__ + "static/media/Piplup_gaussian2.586a3596.png";